<!-- 
  部门&员工下拉选择框
  emit: 
    staff: 提交所选的员工数据
    department: 提交所选的部门数据
 -->
 
<template>
  <div class="dropbox">
    <!-- 员工选择 -->
    <div class="drop-left staff" v-show="currentIndex===1">
      <div class="side">
        <ul>
          <li class="item2" 
          v-for="(item, index) in wordArr"
          :key="index"
          :class="{active: highLight===index}" 
          @click="selectItem(index)">{{item}}</li>
        </ul>
      </div>
      <div class="content">
        <div class="search">
          <input class="search-input" v-model="userSearch" @keyup="searchStaff" placeholder="请输入内容">
          <i class="el-icon-search"></i>
        </div>
        <div class="departmentSearch">
          <el-cascader
          clearable
          :options="newDepartmentTree"
          change-on-select
          @change="chooseDepart"
          filterable
          placeholder="请选择筛选部门"
          >
          </el-cascader>
        </div>
        <div class="list-wrapper" ref="content" @scroll="scrollbar">
          <dl class="staff-list staff-list-hook" v-for="item in wordArr">
            <dt class="word">{{item}}</dt>
            <template v-if="!multiple">
              <dd class="item2" v-for="user in userArray" v-if="user.firstPinyin===item" @click="userSelect(user)">
                <img :src="user.avatar" class="avatar">
                <span class="text">{{user.name}}</span>
              </dd>
            </template>
            <template v-else>
              <label
                class="item2"
                v-for="user in userArray"
                :for="'id'+user.userId"
                v-if="user.firstPinyin===item">
                <input type="checkbox" @change="userSelect(user, 'multiple')" v-model="user.selected" :id="'id'+user.userId" hidden>
                <img :src="user.avatar" class="avatar">
                <span class="text">{{user.name}}</span>
                <span class="el-checkbox__input" :class="{'is-checked': user.selected}">
                  <span class="el-checkbox__inner"></span>
                </span>
              </label>
            </template>
          </dl>
        </div>
      </div>
    </div>
    <!-- 部门选择 -->
    <div class="drop-left department" v-show="currentIndex===0">
      <div class="side">
        <strong class="title">部门选择</strong>
      </div>
      <div class="content">
        <div class="search">
          <el-input
            size="small"
            prefix-icon="el-icon-search"
            v-model="departmentSearch"
            @focus="departSwitch=false"
            @blur="triggerBlur"
            placeholder="请输入内容">
          </el-input>
        </div>
        <div class="list-wrapper tree" v-if="departSwitch">
          <el-tree
            ref="tree"
            :data="departmentTree"
            :props="defaultProps"
            :render-after-expand="false"
            :check-strictly="!isCoupling"
            :show-checkbox="multiple"
            :default-checked-keys="selectIds"
            :filter-node-method="showIds"
            highlight-current
            node-key="id"  
            :default-expanded-keys="[1]"
            @node-click="handleNodeClick"
            @check-change="departChange">            
          </el-tree>
        </div>
        <ul class="depart-search" v-if="!departSwitch">
          <li class="item2" v-for="item in matchDepartment" @click="searchNodeClick(item)">
            {{item.name}}
          </li>
        </ul>
      </div>
    </div>

    <div class="tab-menu" v-if="tabShow">
      <div class="title">
        <span class="item2" :class="{active: currentIndex === 1}" @click="changeTab(1)">员工</span>
        <span class="item2" :class="{active: currentIndex === 0}" @click="changeTab(0)">部门</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message } from 'element-ui'
let lazy

export default {
  props: {
    // 单一模式 0 部门 1 员工
    type: {
      type: Number
    },
    // 是否开启多选模式
    multiple: {
      type: Boolean,
      default: false
    },
    // 多选模式下，已选中的值
    defaultArr: {
      type: Array,
      default: () => []
    },
    isCoupling: { // 是否为耦合，不传默认为false
      default: false,
      type: Boolean
    },
    forbiddenDep: { // 禁止选中的部门
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      userArray: [], // 用户列表
      userSearch: '', // 员工搜索
      departmentTree: [], // 部门列表
      newDepartmentTree: [], // 级联选择的部门列表
      departmentSearch: '', // 部门搜索
      departmentArr: [], // 部门搜索列表
      departSwitch: true, // 切换部门列表样式
      currentIndex: 1, // 当前类型
      scrollY: 0,
      heightArray: [],
      // Tree组件的默认格式
      defaultProps: {
        children: 'childList',
        label: 'name'
      },
      selectArr: this.defaultArr // 已选列表
    }
  },
  created () {
    this.getStaffs()
    this.getDepartment()
  },
  computed: {
    // 将首字母push到一个数组
    wordArr () {
      let arr = []
      for (let i = 0; i < this.userArray.length; i++) {
        if (this.userArray[i].isFirstFp === 1) {
          arr.push(this.userArray[i].firstPinyin)
        }
      }
      return arr
    },
    // 被高亮的行
    highLight () {
      for (let i = 0; i < this.heightArray.length; i++) {
        let height1 = this.heightArray[i]
        let height2 = this.heightArray[i + 1]
        if (!height2 || (this.scrollY >= height1 && this.scrollY < height2)) {
          return i
        }
      }
      return 0
    },
    // 部门搜索列表
    matchDepartment () {
      let val = this.departmentSearch.toString().trim().toLowerCase()
      if (val) {
        return this.departmentArr.filter((item) => {
          if (item.name.toLowerCase().indexOf(val) > -1) {
            return item
          }
        })
      } else {
        return this.departmentArr
      }
    },
    // 单一选择类型，部门 or 员工
    tabShow () {
      if (this.type !== undefined) {
        this.currentIndex = this.type
        return false
      }
      return true
    },
    // 默认已选数据的ID
    selectIds () {
      let keys = []
      if (this.type) {
        keys = this.defaultArr.map(item => item.userId)
      } else {
        keys = this.defaultArr.map(item => item.id)
      }
      this.$nextTick(() => {
        // this.defaultArr.map((item) => {
        //   this.$refs.tree.filter(item.id)
        // })
        this.$refs.tree.setCheckedKeys(keys, false)
      })
      return keys
    }
  },
  methods: {
    // 过滤展示的id
    showIds (value, data, node) {
      // if (!value) return true
      // console.log(data, value, 1111)
      // return false
    },
    // 获取部门列表数据
    getDepartment () {
      let url = '/user/getDepartmentsAjax.html'
      api.post(url, {}, (data) => {
        this.departmentTree = data.result
        this.departmentArr = []
        this.eachArr(this.departmentTree, this.eachArr)
        this.transformDepTree(this.departmentTree, this.newDepartmentTree)
        // this.newDepartmentTree = this.newDepartmentTree[0].children // 去除部门筛选时的全公司选项（先移除，可能线上公司存在一级菜单不止一个选项）
      })
    },
    transformDepTree (arr, newArr) { // 将部门数据转换成级联选择器需要的格式
      arr.forEach((item, index) => {
        newArr.push({
          'label': item.name,
          'value': item.id
        })
        if (item.childList) {
          newArr[index].children = []
          this.transformDepTree(item.childList, newArr[index].children)
        }
      })
    },
    chooseDepart (value) {
      this.getStaffs('', value[value.length - 1])
    },
    // 获取员工列表数据
    getStaffs (name, depId) {
      let url = '/userTreeAjax.html'
      let params = {
        userNameLike: name || '',
        departmentId: depId || ''
      }
      api.post(url, params, (data) => {
        this.userArray = data.userArray.map(item => {
          if (this.selectIds.indexOf(item.userId) > -1) {
            item.selected = true
          } else {
            item.selected = false
          }
          return item
        })
        this.$nextTick(() => {
          this._calculateHeight()
        })
      })
    },

    // 将每一块的高度push到一个数组
    _calculateHeight () {
      const staffList = this.$refs.content.getElementsByClassName('staff-list-hook')
      let height = 0
      this.heightArray.push(height)
      for (let i = 0; i < staffList.length; i++) {
        let item = staffList[i]
        height += item.clientHeight
        this.heightArray.push(height)
      }
    },

    // 选择字母，滚动数据
    selectItem (index) {
      this.$refs.content.scrollTop = this.heightArray[index]
    },

    // 切换部门/员工模式
    changeTab (num) {
      this.currentIndex = num
    },

    // 监听滚动事件
    scrollbar (event) {
      this.scrollY = event.target.scrollTop
    },

    // 员工选择事件
    userSelect (user, multiple) {
      if (multiple) {
        if (user.selected) {
          this.selectArr.push(user)
        } else {
          this.selectArr = this.selectArr.filter(item => {
            if (item.userId !== user.userId) {
              return item
            }
          })
        }
        this.$emit('staff', this.selectArr)
        return
      }
      this.$emit('staff', user.userId, user.name, user.avatar)
      this.$parent.scopeShow = false
    },

    // Tree 节点单击事件
    handleNodeClick (data) {
      if (!this.multiple) {
        this.$emit('department', data.id, data.name)
      }
      this.$parent.scopeShow = false
    },

    // 部门搜索结果点单击事件
    searchNodeClick (data) {
      if (this.multiple) {
        // 声明一个变量status，来判断data是否已存在selectArr中
        let status
        this.selectArr.forEach(item => {
          if (item.id === data.id) {
            status = true
          }
        })
        // 如果部门处于禁用状态，则不允许选中
        if (this.forbiddenDep.length && !this.forbiddenDep.includes(data.id)) {
          Message({
            type: 'error',
            message: '部门不在考核范围，请选择正确的部门！'
          })
          status = true
        }
        // 如果data不存在selectArr中，则执行push动作
        if (!status) {
          this.selectArr.push(data)
          this.$emit('department', this.selectArr)
        }

        // 清空文本输入框
        this.departmentSearch = ''
      } else {
        this.handleNodeClick(data)
      }
    },

    // Tree节点选中事件,部门选中事件
    departChange (obj, status) {
      if (status) { // 处于选中时
        this.selectArr.push({
          id: obj.id,
          name: obj.name
        })
        // if (obj.childList) { // 有子节点时  这里属于回退部分，先不删除zpp
        //   obj.childList.map((item) => {
        //     this.selectArr.push({
        //       id: item.id,
        //       name: item.name
        //     })
        //   })
        // }
      } else { // 处于取消选中时
        this.selectArr = this.selectArr.filter(item => {
          if (item.id !== obj.id) {
            return item
          }
        })
      }
      this.$emit('department', this.selectArr)
      // let selectDepid = [] // 选中的部门id   这里属于回退部分，先不删除zpp
      // this.selectArr.map((item) => { // 去重id值
      //   if (selectDepid.indexOf(item.id) === -1) {
      //     selectDepid.push(item.id)
      //   }
      // })
      // this.$refs.tree.setCheckedKeys(selectDepid)
      // let newarr = [] // 选中需要的部门需要显示在授权部门列表里
      // for (var i = 0; i < this.selectArr.length; i++) { // 去重数组对象
      //   var flag = true
      //   for (var j = 0; j < newarr.length; j++) {
      //     if (this.selectArr[i].id === newarr[j].id) {
      //       flag = false
      //     }
      //   }
      //   if (flag) {
      //     newarr.push(this.selectArr[i])
      //   }
      // }
      // this.$emit('department', newarr) // 发送给父组件需要显示的部门
    },
    // 员工搜索
    searchStaff (e) {
      let val = this.userSearch.toString().trim()
      if (val || e.keyCode === 8) { // 手动删除搜素值的时候允许空字符串，剪切的情况先不管
        window.clearTimeout(lazy)
        lazy = window.setTimeout(() => { this.getStaffs(val) }, 300)
      }
    },

    // 初始化Tree组件
    eachArr (arr, cb) {
      arr.forEach((item) => {
        // 传入禁用项的情况下
        item.disabled = this.forbiddenDep.length && !this.forbiddenDep.includes(item.id) // 对禁用部门添加disabled属性，让tree不可点击

        this.departmentArr.push({
          name: item.name,
          id: item.id
        })
        if (item.childList) {
          cb(item.childList, cb)
        }
      })
      arr = [].concat(arr)
    },

    // 当鼠标离开input 框200毫秒后，关闭搜索模式
    triggerBlur () {
      window.setTimeout(this.closeSearch, 200)
    },

    // 关闭搜索模式
    closeSearch () {
      this.departSwitch = true
    }
  }
}
</script>

<style lang="less">
.dropbox {
  .search {
    .el-input__inner {
      border: 1px solid #dcdfe6;
    }
  }
}
</style>
<style lang="less" scoped>
  @import '../../assets/less/variable.less';
  .dropbox {
    z-index: 9999;
    position: absolute;
    width: 100%;
    height: 450px;
    background-color: #fff;
    box-shadow: 0 0 4px 0 rgba(114, 114, 114, 0.5);
    border-radius: 1px;
    display: flex;
    font-size: 14px;
    &.fade-enter-active, &.fade-leave-active {
      transition: all 0.6s;  
      opacity: 1;
    }
    &.fade-enter, &.fade-leave-active {
      opacity: 0;
    }
    .drop-left {
      flex: 1;
      display: flex;
      .side {
        flex: 0 0 32px;
        width: 32px;
        border-right: 1px solid #eceff5;
        padding: 5px 0;
      }
      .content {
        flex: 1;
        display: flex;
        flex-direction: column;
        .search {
          box-sizing: border-box;
          padding: 9px;
          height: 48px;
          .el-input__inner {
            border: 1px solid #dcdfe6;
          }
        }
        .departmentSearch {
          box-sizing: border-box;
          padding: 9px;
          height: 48px;
          .el-cascader {
            width:100%;
          }
        }
        .list-wrapper {
          flex: 1;
          overflow: auto;
        }
      }
    }
    .staff {
      .side {
        .item2 {
          text-align: center;
          color: #ccc;
          line-height: 18px;
          cursor: pointer;
          &.active, &:hover {
            font-size: 16px;
            color: @bg-orange;
          }
        }
      }
      .content {
        .staff-list {
          .word {
            background-color: @bg-lightblue;
            height: 24px;
            line-height: 24px;
            font-weight: bold;
            padding-left: 10px;
          }
          .item2 {
            display: block;
            position: relative;
            height: 24px;
            padding: 5px 0;
            font-size: 0;
            padding-left: 10px;
            cursor: pointer;
            &:hover {
              background-color: #73acff;
              color: #fff;
            }
            .avatar {
              display: inline-block;
              vertical-align: top;
              width: 24px;
              height: 24px;
              border-radius: 50%;
              margin-right: 6px;
            }
            .text {
              line-height: 24px;
              font-size: 13px;
            }
            .el-checkbox__input {
              position: absolute;
              right: 5px;
              top: 8px;
            }
          }
        }
      }
    }
    .department {
      .side {
        .title {
          padding: 8px;
          // 竖向排列zpp
          display: inline-block;
          line-height: 18px;
          color: @light-gray;
          font-size: 14px;
          border-bottom-width: 0;
          height: auto;
        }
      }
      .el-tree {
        border-width: 0;
      }
      .depart-search {
        max-height: 400px;
        overflow: auto;
        .item2 {
          padding-left: 16px;
          height: 36px;
          line-height: 36px;
          &:hover {
            background-color: #e5e9f2;
          }
        }
      }
    }
    .tab-menu {
      flex: 0 0 32px;
      width: 32px;
      background-color: #eceff5;
      .title {
        padding-top: 48px;
        .item2 {
          display: inline-block;
          padding: 9px;
          font-size: 13px;
          line-height: 1.2;
          text-align: center;
          color: #4e617c;
          cursor: pointer;
          &.active {
            background-color: #fff;
          }
        }
      }
    }
    .search {
      position: relative;
      .search-input {
        width: 100%;
        box-sizing: border-box;
        height: 32px;
        padding-left: 25px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
      }
      .el-icon-search {
        position: absolute;
        top: 20px;
        left: 15px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// dropbox.vue?bfbb66f8